<button (click)="close()"
        aria-label="Close language menu"
        role="button">
    <multisite-flag class="m-r-1"
                    [country]="site.country" />
    <span *ifSize="'!S'"
          class="inline-block">&nbsp;{{site.currency.toLowerCase()}}</span>
</button>
